import { useRef } from "react";

export function useInView() {
  const ref = useRef(null);
  return [ref, true];
}

export function markVisited() {}
